import { Button, Col, Form, Input, Modal, Row } from 'antd';
import React, { useState } from 'react';

const EmailCodeModal = ({modalVisible, setModalVisible, loading, sendCode, checkCode}: any) => {
  const [sent, setSent] = useState(false);
  const [form] = Form.useForm();

  const handleSendCode = async () => {
    const value = await form.getFieldValue('email');
    console.log(value);
    if (!value) {
      form.validateFields(['email']);
      return;
    }
    sendCode({email: value});
    setSent(true);
  }

  const handleOk = async () => {
    const values = await form.validateFields();
    checkCode(values);
  };

  return (
    <Modal
      visible={modalVisible}
      onCancel={() => setModalVisible(false)}
      title='Verificación de Correo Electrónico'
      width='80vh'
      bodyStyle={{ padding: '40px' }}
      centered
      footer={null}
      closable
    >
      <Form layout='vertical' form={form}>
        <Row>
          <Col xl={12} xs={12}>
            <Form.Item label='Email' name='email' rules={[{ required: true, message: 'Debe ingresar el email' }]}>
              <Input
                placeholder='Email'
              />
            </Form.Item>
          </Col>
        { sent &&
          <Col xl={12} xs={12}>
            <Form.Item label='Código' name='code' rules={[{ required: sent, message: 'Debe ingresar el código' }]}>
              <Input
                placeholder='Código'
              />
            </Form.Item>
          </Col> }
        </Row>
        <Row style={{paddingTop:'10px', paddingBottom:'10px'}}>
          <Button loading={loading} type='primary'onClick={handleSendCode}>
            {sent ? 'Reenviar Código' :'Solicitar Código'}
          </Button>
        </Row>
        { sent &&
        <Row>
          <Button loading={loading} type='primary' onClick={handleOk}>
            Verificar
          </Button>
        </Row>
        }
      </Form>
    </Modal>
  );
};

export default EmailCodeModal;